(function () {
  var SHADOW_STYLE_ID = 'hero-quote-banner-shadow-styles';
  var SUBMIT_LABEL = '2. GET FREE INSTANT QUOTE';

  function getShadowRoot(container) {
    var nodes = container.querySelectorAll('form-embed, shopify-forms-embed, [data-form-root]');
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].shadowRoot) return nodes[i].shadowRoot;
    }
    return null;
  }

  function injectShadowStyles(shadowRoot, stylesheetUrl) {
    if (!shadowRoot || !stylesheetUrl || shadowRoot.getElementById(SHADOW_STYLE_ID)) return;
    var link = document.createElement('link');
    link.id = SHADOW_STYLE_ID;
    link.rel = 'stylesheet';
    link.href = stylesheetUrl;
    shadowRoot.appendChild(link);
  }

  function updateSubmitButton(shadowRoot) {
    if (!shadowRoot) return;
    var buttons = shadowRoot.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      if (button.type !== 'submit' && !/submit|quote/i.test(button.textContent || '')) continue;
      if (button.closest && button.closest('[data-testid="success-screen"], [data-testid="form-success"]')) continue;

      if (button.textContent !== SUBMIT_LABEL) {
        button.textContent = SUBMIT_LABEL;
      }
    }
  }

  function checkFormSuccess(inner, shadowRoot) {
    var selector = '[data-testid="success-screen"], [data-testid="form-success"], [data-testid="banner-success"], [data-testid="success-title"], [class*="success"], [class*="Success"]';
    if (inner.querySelector(selector)) return true;
    if (shadowRoot) {
      if (shadowRoot.querySelector(selector)) return true;
      var text = shadowRoot.textContent || '';
      if (text.indexOf('Thank you') !== -1 || text.indexOf('received your project') !== -1) {
        return true;
      }
    }
    return false;
  }

  function showThankYouCard(wrapper) {
    if (!wrapper) return;
    var inner = wrapper.querySelector('.hero-quote-banner__form-inner');
    var thankYou = wrapper.querySelector('.quote-thank-you');
    if (inner && inner.style.display !== 'none') {
      inner.style.display = 'none';
    }
    if (thankYou && thankYou.style.display !== 'block') {
      thankYou.style.display = 'block';
    }
  }

  function showFormWrapper(wrapper) {
    if (!wrapper) return;
    var inner = wrapper.querySelector('.hero-quote-banner__form-inner');
    var thankYou = wrapper.querySelector('.quote-thank-you');
    if (thankYou && thankYou.style.display !== 'none') {
      thankYou.style.display = 'none';
    }
    if (inner && inner.style.display !== 'block') {
      inner.style.display = 'block';
    }
  }

  function resetFormEmbed(wrapper) {
    var formContainer = wrapper.querySelector('.hero-quote-banner__form');
    if (!formContainer) return;

    var currentEmbed = formContainer.querySelector('shopify-forms-embed, form-embed');
    if (currentEmbed) {
      var tag = currentEmbed.tagName.toLowerCase();
      var newEmbed = document.createElement(tag);
      Array.from(currentEmbed.attributes).forEach(function (attr) {
        newEmbed.setAttribute(attr.name, attr.value);
      });
      currentEmbed.parentNode.replaceChild(newEmbed, currentEmbed);
    }
  }

  function applyFormStyles(inner) {
    var wrapper = inner.closest('.hero-quote-banner__form-wrapper') || inner.parentElement;
    var shadowRoot = getShadowRoot(inner);

    if (shadowRoot) {
      injectShadowStyles(shadowRoot, inner.getAttribute('data-form-stylesheet'));
      updateSubmitButton(shadowRoot);
    }

    if (checkFormSuccess(inner, shadowRoot)) {
      showThankYouCard(wrapper);
    }
  }

  function setupForm(inner) {
    var isRunning = false;

    function safeApply() {
      if (isRunning) return;
      isRunning = true;
      try {
        applyFormStyles(inner);
      } finally {
        isRunning = false;
      }
    }

    var attempts = 0;
    var poll = setInterval(function () {
      attempts += 1;
      safeApply();
      if (attempts >= 25) {
        clearInterval(poll);
      }
    }, 400);

    safeApply();

    var observer = new MutationObserver(function () {
      safeApply();
    });
    observer.observe(inner, { childList: true, subtree: true });

    var shadowCheckInterval = setInterval(function () {
      var shadowRoot = getShadowRoot(inner);
      if (shadowRoot) {
        clearInterval(shadowCheckInterval);
        if (!shadowRoot._hasCustomObserver) {
          shadowRoot._hasCustomObserver = true;
          var shadowObserver = new MutationObserver(function () {
            safeApply();
          });
          shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
        }
      }
    }, 400);
  }

  function init() {
    document.querySelectorAll('.hero-quote-banner__form-inner').forEach(setupForm);

    document.addEventListener('click', function (e) {
      var backBtn = e.target.closest('#quote-another-btn');
      if (backBtn) {
        window.location.reload();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

function applyFormStyles(inner) {
  var wrapper = inner.closest('.hero-quote-banner__form-wrapper') || inner.parentElement;
  var shadowRoot = getShadowRoot(inner);

  if (shadowRoot) {
    injectShadowStyles(shadowRoot, inner.getAttribute('data-form-stylesheet'));
    injectButtonStyle(shadowRoot);
    updateSubmitButton(shadowRoot);
  }

  if (checkFormSuccess(inner, shadowRoot)) {
    showThankYouCard(wrapper);
  }
}